/**
 * collection-bundle.js
 * Bundle builder de la page collection.
 *
 * Ce fichier gère le flux « produit à variantes » : clic sur « Choisir les
 * options » → ouverture du modal (quick-view) → sélection → « Ajouter au pack ».
 * Il réutilise :
 *  - le web component <product-bundle> (assets/theme.js) via l'événement
 *    bundle:added (mêmes détails { product, variant } que l'offre groupée) ;
 *  - la validation de custom_preselect-variant.js (encadré rouge + scroll sur le
 *    1er sélecteur non choisi) : on ne fait rien tant que la sélection est
 *    incomplète, preselect s'en charge.
 *
 * Le moteur de remise + barre de progression (règles tiered / conditionnelles
 * ancrées) est ajouté à l'étape suivante.
 */
(function () {
  'use strict';

  function addToPackLabel() {
    return (
      (window.theme && theme.variantStrings && theme.variantStrings.addToPack) ||
      'Ajouter au pack'
    );
  }

  // La sélection de variantes du modal est-elle incomplète ?
  // data-validation-initialized = preselect a démarré ;
  // data-validation-active arrive un peu après (fin d'init) — ne pas l'exiger
  // ici sinon le faux submit d'ouverture ne part jamais.
  function needsSelection(quickView) {
    return (
      quickView.hasAttribute('data-validation-initialized') &&
      !quickView.hasAttribute('data-variant-selection-complete')
    );
  }

  // 1) Ouverture depuis une carte : mémorise le contexte bundle sur la quick-view.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-bundle-choose-options]');
    if (!trigger) return;
    var quickView = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!quickView) return;
    quickView.dataset.bundleControls = trigger.getAttribute('data-bundle-controls') || '';
    quickView.__bundleSourceCard = trigger.closest('.product-card');
  });

  // 1quater) Ligne cadeau : « Choisir » scrolle vers la grille cadeaux et, sur
  //          mobile, ferme le bundle (sinon la barre fixe masque la grille).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bundle-gift-choose]');
    if (!btn) return;
    var grid = document.getElementById(btn.getAttribute('data-gifts-target'));
    if (!grid) return;
    if (window.matchMedia('(max-width: 1279px)').matches) {
      var pack = btn.closest('.collection-bundle');
      if (pack) pack.classList.remove('active');
    }
    grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // 1quinquies) Indicateur cadeau flottant : scrolle la ligne cadeau dans la vue,
  //             UNIQUEMENT dans le conteneur du pack (jamais la page).
  document.addEventListener('click', function (e) {
    var jump = e.target.closest && e.target.closest('[data-bundle-gift-jump]');
    if (!jump) return;
    var pack = jump.closest('.collection-bundle');
    var line = pack && pack.querySelector('[data-bundle-gift-line]');
    var scroller = pack && pack.querySelector('.collection-bundle__scroll-content');
    if (!line || !scroller) return;
    var lineRect = line.getBoundingClientRect();
    var scRect = scroller.getBoundingClientRect();
    // Centre la ligne dans la zone visible du pack, sans toucher au scroll de page.
    var target =
      scroller.scrollTop +
      (lineRect.top - scRect.top) -
      (scRect.height - lineRect.height) / 2;
    scroller.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });
  });

  // 1sexies) Ouverture / fermeture du bundle : réévalue l'indicateur cadeau
  //          IMMÉDIATEMENT (sans attendre un scroll) + après l'animation.
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('product-bundle-toggle-button');
    if (!toggle) return;
    var pack = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!pack || !pack.matches('.collection-bundle')) return;
    requestAnimationFrame(function () {
      updateGiftJump(pack);
    });
    setTimeout(function () {
      updateGiftJump(pack);
    }, 500);
  });

  // 1quater bis) Retire les slots gabarits vides ("available", pas de variante
  //          choisie) juste avant l'ATC natif du web component (theme.js,
  //          ProductBundle.onSubmitHandler). Capture sur document → s'exécute
  //          AVANT le listener posé sur le bouton par le web component. Sans
  //          ça, un pack qui compte moins de produits DISTINCTS que `minimum`
  //          (le regroupement ci-dessous réutilise un slot existant au lieu
  //          d'en créer un par unité) envoie un item { id: null } au panier →
  //          "Required parameter missing or invalid: id". [NE PAS toucher à
  //          theme.js pour ce correctif : le fichier dépasse la limite de
  //          taille (256 Ko) au-delà de laquelle la synchro GitHub → Shopify
  //          saute silencieusement le fichier.]
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('[data-product-bundle-submit]');
      if (!btn) return;
      var pack = btn.closest('product-bundle');
      if (!pack) return;
      pack.querySelectorAll('[data-product-bundle-variant][available]').forEach(function (el) {
        el.remove();
      });
    },
    true
  );

  // 1bis) Ajout mono-variante : le <form is="product-bundle-form"> ne fait pas de
  //       fetch, mais HoverButton pose aria-busy=true sur le bouton au submit et ne
  //       le retire jamais (spinner infini). On le retire après l'ajout au pack.
  function clearBundleAddBusy() {
    document
      .querySelectorAll('.product-card__bundle-add [aria-busy="true"]')
      .forEach(function (btn) {
        btn.removeAttribute('aria-busy');
      });
  }

  // 1ter) Regroupement des produits identiques : capture au niveau document →
  //       s'exécute AVANT le listener du web component posé sur le <product-bundle>.
  //       Si un slot contient déjà cette variante, on incrémente sa quantité au
  //       lieu de créer un nouveau slot (stopImmediatePropagation).
  document.addEventListener(
    'bundle:added',
    function (e) {
      requestAnimationFrame(clearBundleAddBusy);

      var pack = e.target;
      if (!pack || !pack.matches || !pack.matches('product-bundle.collection-bundle')) return;
      // Ouvre le bundle au 1er ajout (desktop + mobile).
      pack.classList.add('active');
      var variant = e.detail && e.detail.variant;
      if (!variant) return;

      // [CUSTOM] Mode progressif : PAS de regroupement — chaque ajout d'un produit
      // (même dupliqué) crée un slot distinct = une ligne = une position/remise.
      // Le web component autorise les doublons (pas de data-prevent-duplicate).
      if (isProgressive()) return;

      var existing = null;
      pack.querySelectorAll('[data-product-bundle-variant][data-variant-id]').forEach(function (slot) {
        if (!existing && String(slot.getAttribute('data-variant-id')) === String(variant.id)) {
          existing = slot;
        }
      });
      if (!existing) return; // nouveau produit → le web component crée le slot

      // Respecte le plafond de quantité (dernier palier), sauf si illimité.
      var max = parseInt(pack.getAttribute('data-maximum'), 10) || 0;
      var unlimited = pack.hasAttribute('data-unlimited');
      var totalQty = 0;
      pack.querySelectorAll('[data-product-bundle-variant][data-variant-id] quantity-input').forEach(function (qi) {
        totalQty += parseInt(qi.value, 10) || 0;
      });
      if (!unlimited && max > 0 && totalQty >= max) {
        e.stopImmediatePropagation();
        return;
      }

      e.stopImmediatePropagation();
      var qi = existing.querySelector('quantity-input');
      var input = qi && qi.input;
      if (input) {
        input.value = (parseInt(input.value, 10) || 1) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      pack.dispatchEvent(new Event('change', { bubbles: true }));
    },
    true
  );

  // Reconstitue la variante d'un slot déjà rendu, au format attendu par
  // ProductBundle.addVariant (theme.js) : id, prix, options, vignette.
  function variantFromSlot(slot) {
    var priceEl = slot.querySelector('[data-product-bundle-variant-price]');
    var img = slot.querySelector('[data-product-bundle-variant-media] img');
    var options = [];
    slot.querySelectorAll('[data-product-bundle-variant-content] ul li').forEach(function (li) {
      options.push(li.textContent.trim());
    });
    return {
      id: slot.getAttribute('data-variant-id'),
      price: priceEl ? parseInt(priceEl.getAttribute('data-price'), 10) || 0 : 0,
      options: options,
      default_featured_media: stripImageSize(img && img.getAttribute('src'))
    };
  }

  // Retire les paramètres de redimensionnement d'une URL d'image : le web
  // component en rajoute (getResizedImageSrc) à chaque rendu, sinon ils
  // s'empilent d'une copie de slot à l'autre.
  function stripImageSize(url) {
    if (!url) return '';
    var parts = url.split('?');
    if (parts.length < 2) return url;
    var qs = parts[1].split('&').filter(function (param) {
      return param.indexOf('width=') !== 0 && param.indexOf('height=') !== 0;
    });
    return qs.length ? parts[0] + '?' + qs.join('&') : parts[0];
  }

  // 1quater) Nettoyage du contexte bundle à la fermeture du modal : sinon une
  //          réouverture via l'œil (quick view normal) relancerait le flux
  //          « choisir les options » (scroll variante + ajout au pack).
  document.addEventListener('modal:afterHide', function (e) {
    var qv = e.target;
    if (qv && qv.tagName === 'QUICK-VIEW') {
      qv.removeAttribute('data-bundle-controls');
      qv.__bundleSourceCard = null;
    }
  });

  // 2) Soumission du form ATC du modal en contexte bundle.
  //    Capture au niveau document → s'exécute AVANT le handler capture de
  //    custom_preselect-variant.js (posé sur le <form>). On n'agit que si la
  //    sélection est complète ; sinon on laisse preselect afficher l'encadré rouge.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
      var quickView = form.closest('quick-view[data-bundle-controls]');
      if (!quickView) return;
      if (needsSelection(quickView)) return; // incomplet → preselect gère (encadré rouge + scroll)
      e.preventDefault();
      e.stopImmediatePropagation();
      addSelectionToPack(quickView, form);
    },
    true
  );

  function addSelectionToPack(quickView, form) {
    var controls = quickView.dataset.bundleControls;
    var pack = controls && document.getElementById(controls);
    if (!pack) return;

    var idInput = form.querySelector('[name="id"]');
    var variantId = idInput && idInput.value;
    var variant = findVariant(quickView, variantId);
    if (!variant) return;

    variant = Object.assign({}, variant);
    if (!variant.default_featured_media) {
      var card = quickView.__bundleSourceCard;
      var img = card && card.querySelector('img');
      variant.default_featured_media = (img && (img.currentSrc || img.src)) || '';
    }

    // Le web component lit product.querySelector('[data-product-bundle-title]')
    // et pose l'attribut [locked] sur cet élément (prevent_duplicate) : on passe
    // donc la carte de la grille (qui porte le titre) comme « product ».
    var productEl = quickView.__bundleSourceCard;
    if (!productEl || !productEl.querySelector('[data-product-bundle-title]')) return;

    pack.dispatchEvent(
      new CustomEvent('bundle:added', {
        bubbles: true,
        detail: { product: productEl, variant: variant }
      })
    );

    closeQuickView(quickView);
  }

  function findVariant(quickView, variantId) {
    var dataEl = quickView.querySelector('[data-product-variant-data]');
    if (!dataEl) return null;
    try {
      var data = JSON.parse(dataEl.textContent);
      var variants = data.productVariants || [];
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(variantId)) return variants[i];
      }
    } catch (err) {}
    return null;
  }

  function closeQuickView(quickView) {
    if (typeof quickView.hide === 'function') {
      quickView.hide();
      return;
    }
    var close = quickView.querySelector('.drawer__close');
    if (close) close.click();
  }

  // 3) À l'ouverture du modal en contexte bundle : libellé « Ajouter au pack »
  //    quand la sélection est complète + encadré rouge d'emblée sur le 1er
  //    sélecteur (parité avec le comportement preselect variant désactivé).
  document.addEventListener('quickview:loaded', function () {
    var quickView = document.querySelector('quick-view[open][data-bundle-controls]');
    if (!quickView) return;

    var form = quickView.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    updateSubmitLabel(quickView);
    form.addEventListener('variant:change', function () {
      requestAnimationFrame(function () {
        updateSubmitLabel(quickView);
      });
    });

    // Scroll / encadré rouge : uniquement si ouverture via [data-choose-options]
    // (bouton « Choisir les options »), pas via l'icône œil (data-bundle-choose-options seul).
    waitForValidation(quickView, function () {
      if (!quickView.hasAttribute('data-scroll-to-variants') && !quickView.__scrollToVariants) return;
      if (needsSelection(quickView)) {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        window.setTimeout(function () {
          if (typeof window.refreshQuickViewReadMoreGate === 'function') {
            window.refreshQuickViewReadMoreGate(quickView);
          }
        }, 500);
      }
    });
  });

  function updateSubmitLabel(quickView) {
    if (needsSelection(quickView)) return; // laisse l'invite de preselect
    var btn = quickView.querySelector('form[data-type="add-to-cart-form"] [type="submit"]');
    if (!btn) return;
    var span = btn.querySelector('.btn-text > span') || btn.querySelector('.btn-text');
    if (span) span.textContent = addToPackLabel();
  }

  function waitForValidation(quickView, cb) {
    var tries = 0;
    (function poll() {
      // Active = applyModifiedStyles a tourné (fin d'init) + handler submit prêt.
      if (
        (quickView.hasAttribute('data-validation-active') &&
          quickView.hasAttribute('data-validation-initialized')) ||
        tries > 60
      ) {
        cb();
        return;
      }
      tries++;
      requestAnimationFrame(poll);
    })();
  }

  // 4) Mobile : expose la hauteur du pack pour la réserve sous la grille, et la
  //    hauteur barre FERMÉE pour le bouton filtre (.facet-sticky) — voir CSS.
  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  // Marge sous la grille en plus de la hauteur du pack (dégage aussi le dégradé
  // ::before de 28px au-dessus de la barre).
  var GRID_PAD_EXTRA = 40;

  function measureClosedBarHeight(column) {
    var pack = column.querySelector('.collection-bundle');
    var head = column.querySelector('.collection-bundle__head-wrap');
    var footer = column.querySelector('.collection-bundle__footer-wrap');
    if (!pack || pack.classList.contains('active') || !head || !footer) return;
    // Fermé mobile : tête + footer = hauteur visible (évite inner.offsetHeight
    // gonflé par --cb-footer-h fallback avant la mesure JS du footer).
    column.__closedBarHeight = head.offsetHeight + footer.offsetHeight;
  }

  // @param {{remeasure?: boolean}} [opts] - remeasure:false évite de mesurer la
  // barre fermée pendant l'animation de fermeture (hauteur transitoire).
  function updateBarHeight(opts) {
    var column = document.querySelector('.collection-bundle-column');
    if (!column) return;
    var remeasure = !opts || opts.remeasure !== false;
    var isMobile = window.matchMedia('(max-width: 1279px)').matches;
    var pack = column.querySelector('.collection-bundle');
    var isOpen = !!(pack && pack.classList.contains('active'));
    // Bouton filtre : toujours calé sur la barre FERMÉE (ne bouge pas à l'ouverture,
    // le pack ouvert passe par-dessus, z-index supérieur).
    if (isMobile && remeasure && !isOpen) measureClosedBarHeight(column);
    // Si la 1re mesure a eu lieu hors écran / avant layout, réessaie dès que visible.
    if (isMobile && !isOpen && !(column.__closedBarHeight > 0)) {
      measureClosedBarHeight(column);
    }
    var closed = column.__closedBarHeight || 0;
    var gridPad = 0;
    var filterOffset = 0;
    if (isMobile && column.classList.contains('is-visible')) {
      filterOffset = closed;
      // Réserve grille = hauteur globale visible du pack (ouverte ou fermée) + marge.
      var packH = isOpen ? column.offsetHeight || closed : closed;
      gridPad = packH + GRID_PAD_EXTRA;
    }
    document.documentElement.style.setProperty('--collection-bundle-bar-height', gridPad + 'px');
    document.documentElement.style.setProperty('--collection-bundle-filter-offset', filterOffset + 'px');
  }

  // Hauteur du footer (calque fixe) → réserve en bas de la zone scroll pour que le
  // contenu défile derrière le bouton. Mesurée IMMÉDIATEMENT (le footer ne s'anime
  // pas en hauteur, son padding bascule net) : si on la différait, la réserve se
  // réajusterait en retard → petit espace qui se referme avec un délai à la fermeture.
  function updateFooterHeight() {
    var column = document.querySelector('.collection-bundle-column');
    if (!column) return;
    var inner = column.querySelector('.collection-bundle__inner');
    var footer = column.querySelector('.collection-bundle__footer-wrap');
    if (inner && footer) {
      inner.style.setProperty('--cb-footer-h', footer.offsetHeight + 'px');
    }
  }

  function syncBarLayout() {
    updateFooterHeight();
    updateBarHeight();
  }

  function initBarHeight() {
    var column = document.querySelector('.collection-bundle-column');
    if (!column) return;
    syncBarLayout();
    window.addEventListener('resize', debounce(syncBarLayout, 150));
    var pack = column.querySelector('.collection-bundle');
    if (!pack) return;
    // Hauteur barre FERMÉE : différée APRÈS l'animation (~0.45s) — mesurer pendant
    // le repli capterait une hauteur transitoire, figée ensuite → le bouton filtre
    // resterait déplacé. Ouvert : padding grille mis à jour tout de suite (+ ResizeObserver).
    var settle = debounce(syncBarLayout, 500);
    function onChange() {
      requestAnimationFrame(function () {
        updateFooterHeight();
        updateBarHeight({ remeasure: false });
      });
      settle();
    }
    new MutationObserver(onChange).observe(pack, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
    });
    pack.addEventListener('bundle:added', onChange);
    pack.addEventListener('bundle:removed', onChange);
    // Pack ouvert : la hauteur globale change (animation, lignes ajoutées) →
    // la réserve sous la grille suit en direct.
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(
        debounce(function () {
          if (pack.classList.contains('active')) {
            updateBarHeight({ remeasure: false });
          }
        }, 50)
      ).observe(column);
    }
  }

  // Apparition / disparition du pack au scroll (mobile) : seuil fixe à 65 % de
  // la hauteur d'écran (bas de la section collection, hors padding dynamique).
  // Ouvert / fermé n'influence pas le seuil — seul le padding grille change.
  // Le bouton filtre (.facet-sticky) suit exactement le même seuil.
  function initReveal() {
    var column = document.querySelector('.collection-bundle-column');
    if (!column) return;
    var target = document.querySelector('.collection-section');
    if (!target) {
      column.classList.add('is-visible');
      syncBarLayout();
      syncFacetSticky(true);
      return;
    }

    function appliedPadPx() {
      if (!column.classList.contains('is-visible')) return 0;
      return (
        parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue(
            '--collection-bundle-bar-height'
          )
        ) || 0
      );
    }

    function syncFacetSticky(visible) {
      var sticky = document.querySelector('facet-sticky');
      if (!sticky) return;
      if (typeof sticky.syncWithBundle === 'function') {
        sticky.syncWithBundle(visible);
        return;
      }
      // Fallback si le custom element n'est pas encore upgradé
      var btn = sticky.querySelector('.button');
      if (!btn || typeof Motion === 'undefined' || !Motion.animate) return;
      if (visible) {
        Motion.animate(
          btn,
          { opacity: 1, visibility: 'visible', transform: ['translateY(15px)', 'translateY(0)'] },
          { duration: 1, easing: [0.16, 1, 0.3, 1] }
        );
      } else {
        Motion.animate(
          btn,
          { opacity: 0, visibility: 'hidden', transform: ['translateY(0)', 'translateY(15px)'] },
          { duration: 1, easing: [0.16, 1, 0.3, 1] }
        );
      }
    }

    function updateReveal() {
      var rect = target.getBoundingClientRect();
      var thresholdY = window.innerHeight * 0.65;
      // Bas « contenu » stable : on retire le padding grille (sinon hystérésis
      // open/close / show-hide). Seuil = ce bas passe la ligne des 65 %.
      var contentBottom = rect.bottom - appliedPadPx();
      var visible = contentBottom > thresholdY && rect.top < window.innerHeight;
      var wasVisible = column.classList.contains('is-visible');
      var first = !column.__revealReady;
      column.__revealReady = true;
      if (!first && wasVisible === visible) return;
      column.classList.toggle('is-visible', visible);
      syncBarLayout();
      syncFacetSticky(visible);
      if (visible && !(column.__closedBarHeight > 0)) {
        requestAnimationFrame(function () {
          measureClosedBarHeight(column);
          updateBarHeight({ remeasure: false });
        });
      }
    }

    window.addEventListener('scroll', updateReveal, { passive: true });
    window.addEventListener('resize', debounce(updateReveal, 150));
    updateReveal();
  }

  function initColumn() {
    initBarHeight();
    initReveal();
  }

  if (document.readyState !== 'loading') initColumn();
  else document.addEventListener('DOMContentLoaded', initColumn);

  /* ───────────────────────────────────────────────────────────────
     Moteur remise + barre de progression (règles tiered / conditionnelles
     ancrées, émises par snippets/collection-bundle-config.liquid).

     Aperçu live du pack en cours de construction : les remises exactes sont
     appliquées au checkout par les remises Shopify — ceci est un aperçu.
     ─────────────────────────────────────────────────────────────── */
  function money(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      var fmt = theme.settings.currencyCodeEnabled
        ? theme.settings.moneyWithCurrencyFormat
        : theme.settings.moneyFormat;
      return theme.Currency.formatMoney(Math.round(cents), fmt);
    }
    return (cents / 100).toFixed(2);
  }

  // [CUSTOM] Prix à 0 → « Offert » quand settings.product_free_display vaut
  // price_free (même règle que tiered-bundle.js regularPriceText, pour un
  // affichage des produits gratuits cohérent sur tout le site).
  function priceOrFree(cents) {
    var rules = window.__collectionBundleRules;
    if (Math.round(cents) === 0 && (!rules || rules.freeDisplayMode === 'price_free')) {
      return (rules && rules.i18n && rules.i18n.free) || 'Offert';
    }
    return money(cents);
  }

  function moneyPlain(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(Math.round(cents), theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  // Lignes du pack : { productId, unit (cents), qty }
  function readPackLines(pack) {
    var lines = [];
    pack.querySelectorAll('[data-product-bundle-variant][data-variant-id]').forEach(function (slot) {
      var card = slot.product;
      var productId = card && card.dataset ? parseInt(card.dataset.productId, 10) : null;
      var priceEl = slot.querySelector('[data-product-bundle-variant-price]');
      var qtyEl = slot.querySelector('quantity-input');
      lines.push({
        productId: productId,
        unit: priceEl ? parseInt(priceEl.getAttribute('data-price'), 10) || 0 : 0,
        qty: qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1
      });
    });
    return lines;
  }

  // [CUSTOM] Lignes « produit du panier » : produits déjà au panier éligibles aux
  // règles ancrées. Elles sont affichées DANS le pack, avec le même aperçu que
  // les produits ajoutés (vignette, options, prix remisé, balises) — même forme
  // que readPackLines, plus les données d'affichage émises par
  // collection-bundle-config.liquid.
  // [CUSTOM] Titres courts (metafield short_heading), comme les cartes produit et
  // le panier. Deux sources : le titre émis par Liquid (mémorisé au démarrage) et
  // la carte du produit dans la grille, qui l'expose déjà via
  // data-product-bundle-title — la carte prime, c'est la source des lignes du
  // pack. /cart.js ne renvoyant que le titre complet, la mémoire évite de le voir
  // réapparaître après un changement de panier.
  var shortTitles = {};

  function seedShortTitles() {
    var rules = window.__collectionBundleRules;
    ((rules && rules.cartItems) || []).forEach(function (it) {
      if (it.t) shortTitles[it.id] = it.t;
    });
  }

  function shortTitleFor(productId, fallback) {
    var titleEl = document.querySelector(
      '.product-card[data-product-id="' + productId + '"] [data-product-bundle-title]'
    );
    if (titleEl) shortTitles[productId] = titleEl.textContent.trim();
    return shortTitles[productId] || fallback || '';
  }

  function readCartLines() {
    var rules = window.__collectionBundleRules;
    var eligible = unionTieredIds();
    var lines = [];
    ((rules && rules.cartItems) || []).forEach(function (it) {
      if (!includes(eligible, it.id)) return;
      lines.push({
        productId: it.id,
        unit: parseInt(it.p, 10) || 0,
        qty: parseInt(it.q, 10) || 1,
        title: shortTitleFor(it.id, it.t),
        options: it.o || '',
        image: it.img || ''
      });
    });
    return lines;
  }

  // Vignette redimensionnée (même convention que ProductBundle.getResizedImageSrc
  // dans theme.js) : les URLs venant de /cart.js sont brutes, celles émises par
  // Liquid portent déjà un width.
  function resizedSrc(url, width) {
    if (!url) return '';
    if (url.indexOf('width=') !== -1) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  // Options d'une variante du panier (« Noir / M ») → liste de valeurs.
  function optionValues(variantTitle) {
    if (!variantTitle || variantTitle === 'Default Title') return [];
    return variantTitle.split(' / ').filter(function (v) {
      return v && v !== 'Default Title';
    });
  }

  function includes(ids, id) {
    return id != null && ids.indexOf(id) !== -1;
  }

  // Quantité déjà au panier pour un ensemble de produits (produits éligibles).
  function cartQtyFor(ids) {
    var rules = window.__collectionBundleRules;
    var items = (rules && rules.cartItems) || [];
    if (!ids || !ids.length || !items.length) return 0;
    var set = {};
    ids.forEach(function (id) { set[id] = true; });
    var q = 0;
    items.forEach(function (it) { if (set[it.id]) q += it.q; });
    return q;
  }

  // Union des IDs produits de tous les paliers tiered ancrés.
  function unionTieredIds() {
    var rules = window.__collectionBundleRules;
    var ids = [];
    var seen = {};
    if (rules && rules.tiered) {
      rules.tiered.forEach(function (r) {
        (r.productIds || []).forEach(function (id) {
          if (!seen[id]) { seen[id] = 1; ids.push(id); }
        });
      });
    }
    return ids;
  }

  // [CUSTOM] Remise progressive : au moins une règle tiered ancrée porte le
  // metafield progressive_discount. Les paliers deviennent des SEUILS DE
  // POSITION (le Nᵉ produit) : chaque produit reçoit la remise de sa position,
  // classé par prix (le plus cher = position basse / remise la plus faible ; le
  // moins cher = position haute / remise la plus forte). Même logique que
  // tiered-bundle.js.
  function isProgressive() {
    var rules = window.__collectionBundleRules;
    return !!(
      rules &&
      (rules.tiered || []).some(function (r) {
        return r.progressive;
      })
    );
  }

  // % de la position pos (1-based) : palier le plus haut dont le seuil <= pos.
  // Au-delà du dernier palier, on conserve le % du dernier (progression
  // illimitée ; le plafond de quantité du pack limite déjà si non illimité).
  function pctForPosition(pos, tiers) {
    var pct = 0;
    for (var i = 0; i < tiers.length; i++) {
      if (pos >= tiers[i].qty) pct = tiers[i].pct;
      else break;
    }
    return pct;
  }

  // Ordinal FR court : 1 → « 1er », n → « nᵉ ».
  function ordinalFr(n) {
    return n === 1 ? '1er' : n + 'ᵉ';
  }

  // Seuil (position) du dernier palier progressif.
  function lastTierQty() {
    var tiers = getTiers();
    return tiers.length ? tiers[tiers.length - 1].qty : 0;
  }

  // Libellé de position : « 2ᵉ produit », et à partir du dernier palier « Nᵉ+
  // produit » (le « + » signale que tous les produits suivants ont cette remise).
  function positionLabel(pos, lastQty) {
    if (lastQty > 0 && pos >= lastQty) return ordinalFr(lastQty) + '+ produit';
    return ordinalFr(pos) + ' produit';
  }

  // Plan progressif : classe toutes les unités éligibles (panier + pack) par prix
  // décroissant, puis affecte à chaque unité le % de sa position. Regroupe par
  // ligne — une ligne du pack = un produit (prevent_duplicate), une ligne du
  // panier = un article du panier.
  // Retourne { pack: { li: { pcts, positions } }, cart: { ci: { pcts, positions } } }.
  function computeProgressivePlan(lines, giftByLine, cartLines) {
    var tiers = getTiers();
    // [CUSTOM] La position d'une unité est son RANG PAR PRIX parmi TOUTES les
    // unités éligibles (panier + pack), pas un simple décalage après le panier :
    // un produit du pack plus cher qu'un article déjà au panier prend une
    // position plus basse (moins remisée) et repousse ce dernier. Même
    // classement que computeUnitDiscounts dans tiered-bundle.js — sinon le pack
    // annonce un palier que le panier réel ne confirmera pas.
    var units = [];
    (cartLines || []).forEach(function (l, ci) {
      for (var i = 0; i < l.qty; i++) units.push({ ci: ci, unit: l.unit });
    });
    lines.forEach(function (l, li) {
      for (var i = 0; i < l.qty; i++) units.push({ li: li, unit: l.unit });
    });
    // Prix décroissant ; à prix égal, les unités du panier gardent la priorité.
    units.sort(function (a, b) {
      if (b.unit !== a.unit) return b.unit - a.unit;
      if (a.li === undefined) return -1;
      if (b.li === undefined) return 1;
      return 0;
    });
    var planByLine = {};
    var planByCartLine = {};
    units.forEach(function (u, idx) {
      var pos = idx + 1;
      var pct = pctForPosition(pos, tiers);
      var store = u.li === undefined ? planByCartLine : planByLine;
      var key = u.li === undefined ? u.ci : u.li;
      if (!store[key]) store[key] = { pcts: [], positions: [] };
      store[key].pcts.push(pct);
      store[key].positions.push(pos);
    });
    // [CUSTOM] Cadeaux : les unités offertes de chaque ligne passent à -100 %
    // (elles gardent leur position, seule la remise change).
    Object.keys(giftByLine || {}).forEach(function (li) {
      var plan = planByLine[li];
      if (!plan) return;
      for (var i = 0; i < giftByLine[li] && i < plan.pcts.length; i++) {
        plan.pcts[i] = 100;
      }
    });
    return { pack: planByLine, cart: planByCartLine };
  }

  // [CUSTOM] Cadeaux : quantité éligible d'une règle (pack + panier).
  function matchedQtyFor(rule, lines) {
    var q = cartQtyFor(rule.productIds);
    lines.forEach(function (l) {
      if (includes(rule.productIds, l.productId)) q += l.qty;
    });
    return q;
  }

  // [CUSTOM] Cadeaux accordés par les paliers FRANCHIS (cumulés d'un palier à
  // l'autre), quota RESTANT une fois déduits les cadeaux déjà présents au
  // panier (achetés hors pack, ou déjà offerts par Shopify au checkout) : ils
  // consomment le quota en premier. Choke point unique : giftsGranted (ligne
  // « cadeau »), allocateGiftUnits (badge « Cadeau » sur les lignes du pack) et
  // applyGiftsGridBadges (grille) héritent donc tous automatiquement de cette
  // déduction — dès que le panier contient déjà tous les cadeaux d'un palier,
  // qty tombe à 0 partout (grille grisée, ligne masquée, plus de slot au pack).
  function giftGrantsFor(rule, qty) {
    var grants = [];
    var tiers = (rule.tiers || []).slice().sort(function (a, b) {
      return a.qty - b.qty;
    });
    for (var i = 0; i < tiers.length; i++) {
      if (qty < tiers[i].qty) break;
      if (tiers[i].giftQty > 0 && (tiers[i].giftIds || []).length) {
        var alreadyInCart = cartQtyFor(tiers[i].giftIds);
        var remainingQty = Math.max(0, tiers[i].giftQty - alreadyInCart);
        if (remainingQty > 0) {
          grants.push({ ids: tiers[i].giftIds, qty: remainingQty, badge: tiers[i].giftsBadge || '' });
        }
      }
    }
    return grants;
  }

  // [CUSTOM] Unités du pack offertes (-100 %) : { indexDeLigne: nbOffert }.
  // Les unités les MOINS CHÈRES sont servies en premier, comme l'allocation
  // des remises de palier dans tiered-bundle.js.
  function allocateGiftUnits(rules, lines) {
    var units = [];
    lines.forEach(function (l, li) {
      for (var i = 0; i < l.qty; i++) {
        units.push({ li: li, unit: l.unit, pid: l.productId, gift: false });
      }
    });
    units.sort(function (a, b) {
      return a.unit - b.unit;
    });
    (rules.tiered || []).forEach(function (rule) {
      giftGrantsFor(rule, matchedQtyFor(rule, lines)).forEach(function (grant) {
        var remaining = grant.qty;
        for (var i = 0; i < units.length && remaining > 0; i++) {
          if (units[i].gift || !includes(grant.ids, units[i].pid)) continue;
          units[i].gift = true;
          remaining--;
        }
      });
    });
    var byLine = {};
    units.forEach(function (u) {
      if (u.gift) byLine[u.li] = (byLine[u.li] || 0) + 1;
    });
    return byLine;
  }

  // [CUSTOM] Nombre total de cadeaux débloqués par les paliers franchis (pack + panier).
  function giftsGranted(rules, lines) {
    var total = 0;
    (rules.tiered || []).forEach(function (rule) {
      giftGrantsFor(rule, matchedQtyFor(rule, lines)).forEach(function (g) {
        total += g.qty;
      });
    });
    return total;
  }

  // Palier tiered atteint pour une quantité donnée.
  function tierState(rule, matchedQty) {
    var tiers = (rule.tiers || []).slice().sort(function (a, b) {
      return a.qty - b.qty;
    });
    var reachedPct = 0;
    var next = null;
    for (var i = 0; i < tiers.length; i++) {
      if (matchedQty >= tiers[i].qty) reachedPct = tiers[i].pct;
      else if (!next) next = tiers[i];
    }
    return { reachedPct: reachedPct, next: next, matchedQty: matchedQty };
  }

  function computeDiscount(rules, lines, cartLines) {
    var original = 0;
    lines.forEach(function (l) {
      original += l.unit * l.qty;
    });

    // [CUSTOM] Cadeaux des paliers franchis : ces unités passent à -100 %.
    var giftByLine = allocateGiftUnits(rules, lines);

    // [CUSTOM] Mode progressif : remise par position (voir computeProgressivePlan).
    // planByLine porte le détail par ligne ; renderLinePrices s'en sert pour les
    // balises de position + le prix réduit.
    if (isProgressive()) {
      var plans = computeProgressivePlan(lines, giftByLine, cartLines);
      var planByLine = plans.pack;
      var discountedProg = 0;
      lines.forEach(function (l, li) {
        var plan = planByLine[li];
        if (plan) {
          plan.pcts.forEach(function (pct) {
            discountedProg += l.unit * (1 - pct / 100);
          });
        } else {
          discountedProg += l.unit * l.qty;
        }
      });
      return {
        original: original,
        discounted: Math.max(0, discountedProg),
        driving: null,
        pctByProduct: {},
        planByLine: planByLine,
        cartPlanByLine: plans.cart,
        giftByLine: giftByLine
      };
    }

    // Remise tiered : pct par produit = max des paliers atteints qui le couvrent.
    var pctByProduct = {};
    var driving = null; // règle qui pilote la barre de progression
    (rules.tiered || []).forEach(function (rule) {
      // Inclut les produits déjà au panier éligibles à cette règle.
      var matchedQty = matchedQtyFor(rule, lines);
      var st = tierState(rule, matchedQty);
      rule.productIds.forEach(function (pid) {
        pctByProduct[pid] = Math.max(pctByProduct[pid] || 0, st.reachedPct);
      });
      // Pilote : règle avec un palier suivant et le plus de produits déjà ajoutés.
      if (st.next) {
        if (!driving || st.matchedQty > driving.matchedQty) {
          driving = { rule: rule, matchedQty: st.matchedQty, next: st.next, reachedPct: st.reachedPct };
        }
      } else if (!driving && st.reachedPct > 0) {
        driving = { rule: rule, matchedQty: st.matchedQty, next: null, reachedPct: st.reachedPct };
      }
    });
    if (!driving && (rules.tiered || []).length) {
      var first = rules.tiered[0];
      var st0 = tierState(first, 0);
      driving = { rule: first, matchedQty: 0, next: st0.next, reachedPct: 0 };
    }

    // Les unités offertes ne sont pas facturées ; les autres suivent le palier.
    var discounted = 0;
    lines.forEach(function (l, li) {
      var pct = pctByProduct[l.productId] || 0;
      var paid = Math.max(0, l.qty - (giftByLine[li] || 0));
      discounted += l.unit * paid * (1 - pct / 100);
    });

    return {
      original: original,
      discounted: discounted,
      driving: driving,
      pctByProduct: pctByProduct,
      giftByLine: giftByLine
    };
  }

  // Prix par ligne : structure IDENTIQUE au cart drawer.
  //   .price__regular = prix réduit | .price__sale = prix original barré
  //   .badge.badge--onsale = économie EN DEVISE (sur la ligne, quantité incluse)
  //
  // [CUSTOM] Mode progressif (res.planByLine présent) : la balise devient une
  // badge--highlight portant la POSITION de la ligne (« 2ᵉ produit »), et la
  // balise de réduction en devise n'est PAS affichée (l'économie totale est
  // récapitulée en pied de pack via updateSavedLine).
  function renderLinePrices(pack, res) {
    var pctByProduct = (res && res.pctByProduct) || {};
    var planByLine = (res && res.planByLine) || null;
    var giftByLine = (res && res.giftByLine) || {};
    pack.querySelectorAll('[data-product-bundle-variant][data-variant-id]').forEach(function (slot, li) {
      var priceEl = slot.querySelector('[data-product-bundle-variant-price]');
      if (!priceEl) return;
      var unit = parseInt(priceEl.getAttribute('data-price'), 10) || 0;
      var card = slot.product;
      var pid = card && card.dataset ? parseInt(card.dataset.productId, 10) : null;
      var qtyEl = slot.querySelector('quantity-input');
      var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;

      renderPriceForLine(
        priceEl,
        unit,
        qty,
        planByLine ? planByLine[li] : null,
        (pid && pctByProduct[pid]) || 0,
        // [CUSTOM] Cadeaux : les unités offertes sortent du calcul et sont
        // signalées par une balise dédiée.
        Math.min(giftByLine[li] || 0, qty)
      );
    });
  }

  // [CUSTOM] Rendu du prix d'une ligne, partagé par les produits du pack et par
  // les produits du panier affichés dans le pack (cf. renderCartLinePrices).
  function renderPriceForLine(priceEl, unit, qty, plan, pct, gifts) {
    if (isProgressive()) {
      renderProgressiveLine(priceEl, unit, qty, plan);
      return;
    }
    var lineTotal = unit * (qty - gifts) * (1 - pct / 100);
    var savedLine = unit * qty - lineTotal;
    // Sans cadeau : prix unitaire (rendu historique). Avec cadeaux : totaux de
    // ligne, les unités offertes n'ayant pas le même prix que les autres.
    var reducedShown = gifts > 0 ? lineTotal : unit * (1 - pct / 100);
    var originalShown = gifts > 0 ? unit * qty : unit;
    var reducedHtml = priceOrFree(reducedShown);
    if (savedLine > 0.5) {
      priceEl.className = 'price price--on-sale text-sm flex flex-wrap items-center gap-1d5';
      priceEl.innerHTML =
        '<span class="price__regular whitespace-nowrap">' + reducedHtml + '</span>' +
        '<span class="price__sale inline-flex items-center relative">' + money(originalShown) + '</span>' +
        '<span class="badge badge--onsale flex items-center gap-1d5 font-medium leading-none">-' + money(savedLine) + '</span>' +
        giftBadgeHtml(gifts);
    } else {
      priceEl.className = 'price text-sm flex flex-wrap items-center gap-1d5';
      priceEl.innerHTML = money(unit);
    }
  }

  // [CUSTOM] Découpe les produits du panier en LIGNES affichées, avec la même
  // règle que les produits du pack : une ligne par palier, les unités d'un même
  // palier restant groupées sur une seule ligne (quantité rappelée en « × N »,
  // une ligne panier n'étant pas modifiable ici — cf. normalizeProgressiveSlots).
  // Un produit du panier n'est jamais fusionné avec le même produit ajouté au
  // pack : les deux jeux de lignes sont calculés et rendus séparément (lignes
  // [data-bundle-cart-item] d'un côté, slots [data-product-bundle-variant] de
  // l'autre), même palier et même remise compris.
  // Retourne [{ line, qty, plan }] — plan = null hors mode progressif.
  function computeCartRows(cartLines, res) {
    var cartPlan = (res && res.cartPlanByLine) || null;
    var rows = [];
    cartLines.forEach(function (l, ci) {
      if (!cartPlan) {
        // Palier unique par produit : une seule ligne, quantité du panier.
        rows.push({ line: l, qty: l.qty, plan: null });
        return;
      }
      var plan = cartPlan[ci] || { pcts: [], positions: [] };
      var groups = [];
      for (var i = 0; i < l.qty; i++) {
        var pct = plan.pcts[i] || 0;
        var prev = groups[groups.length - 1];
        if (prev && prev.pct === pct) prev.qty++;
        else groups.push({ pct: pct, qty: 1, pos: plan.positions[i] });
      }
      groups.forEach(function (g) {
        rows.push({ line: l, qty: g.qty, plan: { pcts: [g.pct], positions: [g.pos] } });
      });
    });
    return rows;
  }

  // [CUSTOM] Synchronise les lignes « produit du panier » du pack avec le panier.
  // Une ligne par entrée de computeCartRows, clonée depuis le gabarit du snippet.
  // L'ordre CSS est le prix unitaire décroissant, comme les produits du pack →
  // les lignes s'intercalent selon leur position dans le classement progressif.
  function syncCartLines(pack, rows) {
    var body = pack.querySelector('.product-bundle__body');
    var tpl = pack.querySelector('[data-bundle-cart-item-template]');
    if (!body || !tpl) return;
    var items = Array.prototype.slice.call(pack.querySelectorAll('[data-bundle-cart-item]'));
    // Retire le surplus, réutilise les lignes existantes (pas de reconstruction).
    items.slice(rows.length).forEach(function (el) {
      el.remove();
    });
    rows.forEach(function (row, ri) {
      var l = row.line;
      var el = items[ri];
      if (!el) {
        el = tpl.content.firstElementChild.cloneNode(true);
        body.appendChild(el);
      }
      el.style.order = String(-l.unit);

      var media = el.querySelector('[data-cart-item-media]');
      var img = media && media.querySelector('img');
      var src = resizedSrc(l.image, 360);
      if (media && src) {
        if (!img) {
          img = document.createElement('img');
          img.loading = 'lazy';
          media.appendChild(img);
        }
        if (img.getAttribute('src') !== src) img.setAttribute('src', src);
      } else if (img) {
        img.remove();
      }

      var title = el.querySelector('[data-cart-item-title]');
      if (title && title.textContent !== l.title) title.textContent = l.title;

      var opts = el.querySelector('[data-cart-item-options]');
      if (opts) {
        var values = optionValues(l.options);
        var key = values.join(' / ');
        if (opts.__cbKey !== key) {
          opts.__cbKey = key;
          opts.innerHTML = '';
          values.forEach(function (v) {
            var li = document.createElement('li');
            li.className = 'text-xs text-opacity leading-tight';
            li.textContent = v;
            opts.appendChild(li);
          });
        }
      }

      // Quantité rappelée en « × N » (colonne masquée pour une unité seule),
      // comme les slots du pack fusionnés au dernier palier.
      var qtyEl = el.querySelector('[data-cart-item-qty]');
      var qtyText = row.qty > 1 ? '\u00d7 ' + row.qty : '';
      if (qtyEl) {
        if (qtyEl.textContent !== qtyText) qtyEl.textContent = qtyText;
        qtyEl.parentElement.hidden = !qtyText;
      }
    });
  }

  // [CUSTOM] Prix des lignes « produit du panier » : même rendu que les produits
  // du pack (remise de palier ou balise de position en mode progressif).
  function renderCartLinePrices(pack, rows, res) {
    var pctByProduct = (res && res.pctByProduct) || {};
    pack.querySelectorAll('[data-bundle-cart-item]').forEach(function (el, ri) {
      var row = rows[ri];
      var priceEl = el.querySelector('[data-cart-item-price]');
      if (!row || !priceEl) return;
      // Mode progressif : la ligne ne porte qu'un palier → prix UNITAIRE, la
      // quantité étant rappelée en « × N » (même rendu que les slots fusionnés).
      // Pas de cadeau sur une ligne panier : les cadeaux déjà au panier sont
      // déduits du quota en amont (cf. giftGrantsFor).
      renderPriceForLine(
        priceEl,
        row.line.unit,
        row.plan ? 1 : row.qty,
        row.plan,
        pctByProduct[row.line.productId] || 0,
        0
      );
    });
  }

  // [CUSTOM] Économie portée par les produits du panier affichés dans le pack.
  function cartLinesSaved(cartLines, res) {
    var cartPlan = (res && res.cartPlanByLine) || null;
    var pctByProduct = (res && res.pctByProduct) || {};
    var total = 0;
    cartLines.forEach(function (l, ci) {
      if (cartPlan) {
        var plan = cartPlan[ci];
        if (!plan) return;
        plan.pcts.forEach(function (pct) {
          total += (l.unit * pct) / 100;
        });
      } else {
        total += (l.unit * l.qty * (pctByProduct[l.productId] || 0)) / 100;
      }
    });
    return total;
  }

  // [CUSTOM] Ligne cadeau du pack : placeholder pointillé affiché tant qu'il reste
  // un cadeau débloqué à choisir (débloqués via paliers − déjà ajoutés au pack).
  // Le bouton scrolle vers la grille cadeaux ; masquée dès que tous les cadeaux
  // débloqués sont dans le pack (ou qu'aucun palier cadeau n'est franchi).
  function updateGiftLine(pack, rules, lines, res) {
    var line = pack.querySelector('[data-bundle-gift-line]');
    if (!line) return;
    var granted = giftsGranted(rules, lines);
    var allocated = 0;
    var giftByLine = (res && res.giftByLine) || {};
    Object.keys(giftByLine).forEach(function (li) {
      allocated += giftByLine[li];
    });
    var remaining = Math.max(0, granted - allocated);
    // [CUSTOM] Grille cadeaux : boutons actifs uniquement s'il reste un cadeau à
    // choisir (sinon grisés = « pas encore éligible » ou déjà pris).
    updateGiftGrid(remaining > 0);
    if (remaining <= 0) {
      line.hidden = true;
      requestAnimationFrame(function () { updateGiftJump(pack); });
      return;
    }
    line.hidden = false;
    var sub = line.querySelector('[data-bundle-gift-line-sub]');
    if (sub) sub.textContent = 'x' + remaining;
    // rAF : ce point est atteint pendant les transitions d'ouverture (margin du
    // footer, padding de la zone scroll) déclenchées au même moment (bundle:added) ;
    // laisser une frame pour lire des positions posées, pas transitoires.
    requestAnimationFrame(function () { updateGiftJump(pack); });
  }

  // [CUSTOM] Badge gifts_badge sur les cartes de la grille « Vos cadeaux » (bas
  // de collection) : affiché dès que le PACK (+ panier éligible, cf.
  // matchedQtyFor) atteint un palier accordant un cadeau, UNIQUEMENT sur les
  // cartes des produits offrables de ce palier — et UNIQUEMENT dans la grille de
  // CE pack (pas ailleurs sur le site : le pack n'est pas encore au panier). Le
  // panier RÉEL, sitewide, est géré séparément par applyGiftBadges dans
  // tiered-bundle.js.
  function applyGiftsGridBadges(pack, rules, lines) {
    var chooseBtn = pack.querySelector('[data-bundle-gift-choose]');
    var gridId = chooseBtn && chooseBtn.getAttribute('data-gifts-target');
    var grid = gridId ? document.getElementById(gridId) : null;
    if (!grid) return;

    var textByPid = {};
    (rules.tiered || []).forEach(function (rule) {
      giftGrantsFor(rule, matchedQtyFor(rule, lines)).forEach(function (grant) {
        if (!grant.badge) return;
        (grant.ids || []).forEach(function (pid) {
          if (!textByPid[pid]) textByPid[pid] = grant.badge;
        });
      });
    });

    grid.querySelectorAll('.badges[data-product-id]').forEach(function (badgesEl) {
      var pid = parseInt(badgesEl.getAttribute('data-product-id'), 10);
      var existing = badgesEl.querySelector('[data-tb-gift-badge]');
      var text = textByPid[pid];
      if (!text) {
        if (existing) existing.remove();
        return;
      }
      if (existing) {
        if (existing.textContent !== text) existing.textContent = text;
        return;
      }
      var isVert = !!badgesEl.querySelector('.badge--vertical');
      var span = document.createElement('span');
      span.className = 'badge' + (isVert ? ' badge--vertical' : '') + ' badge--highlight flex items-center gap-1d5 font-medium leading-none rounded-full';
      span.setAttribute('data-tb-gift-badge', '1');
      span.textContent = text;
      badgesEl.appendChild(span);
    });
  }

  // [CUSTOM] Indicateur cadeau flottant : visible quand la ligne cadeau existe
  // mais tombe SOUS la zone visible du scroll (bundle ouvert). Clic → scrolle la
  // ligne dans la vue. Masqué si la ligne est déjà visible / absente / repliée.
  function updateGiftJump(pack) {
    var jump = pack.querySelector('[data-bundle-gift-jump]');
    if (!jump) return;
    var line = pack.querySelector('[data-bundle-gift-line]');
    if (!line || line.hidden || !pack.classList.contains('active')) {
      jump.hidden = true;
      return;
    }
    // L'indicateur apparaît dès que le bouton « choisir » de la ligne cadeau passe
    // SOUS le bouton d'ajout (il n'est alors plus visible dans la zone scroll
    // au-dessus du bouton, il file derrière le footer sticky). Référence : le haut
    // du bouton d'ajout ; on compare le bas du bouton « choisir ». Une marge est
    // exigée (pas juste 0px) : sans elle, l'écart naturel entre les deux boutons
    // est parfois si faible que l'indicateur se déclenchait alors que « choisir »
    // était encore clairement visible.
    var atc = pack.querySelector('[data-product-bundle-submit]');
    var choose = line.querySelector('[data-bundle-gift-choose]') || line;
    if (!atc) {
      jump.hidden = true;
      return;
    }
    var buffer = 16; // px : « choisir » doit être passé nettement sous le bouton
    var atcTop = atc.getBoundingClientRect().top;
    var chooseBottom = choose.getBoundingClientRect().bottom;
    jump.hidden = chooseBottom <= atcTop + buffer;
  }

  // [CUSTOM] Grille cadeaux (bas de collection) : active/grise ses boutons d'ajout
  // selon l'éligibilité (un cadeau reste à choisir).
  function updateGiftGrid(eligible) {
    document.querySelectorAll('.collection-bundle-gifts').forEach(function (grid) {
      grid.classList.toggle('is-locked', !eligible);
    });
  }

  // [CUSTOM] Cadeaux : la quantité d'une ligne cadeau ne peut pas dépasser le
  // nombre de cadeaux encore accordés par les paliers atteints (quota du palier
  // courant). Au maximum, le bouton « + » est neutralisé (attribut sur la ligne)
  // et l'input porte un max natif — le web component refuse alors la valeur.
  function applyGiftQuantityLimits(pack, rules, lines, res) {
    var isGiftProduct = {};
    (rules.tiered || []).forEach(function (rule) {
      (rule.tiers || []).forEach(function (t) {
        (t.giftIds || []).forEach(function (id) { isGiftProduct[id] = true; });
      });
    });

    var giftByLine = (res && res.giftByLine) || {};
    var allocated = 0;
    Object.keys(giftByLine).forEach(function (li) { allocated += giftByLine[li]; });
    // Cadeaux accordés mais pas encore posés sur une ligne : une ligne cadeau
    // peut encore les absorber.
    var spare = Math.max(0, giftsGranted(rules, lines) - allocated);

    pack.querySelectorAll('[data-product-bundle-variant][data-variant-id]').forEach(function (slot, li) {
      var input = slot.querySelector('quantity-input input');
      if (!input) return;
      var card = slot.product;
      var pid = card && card.dataset ? parseInt(card.dataset.productId, 10) : null;
      if (!pid || !isGiftProduct[pid]) {
        input.removeAttribute('max');
        slot.removeAttribute('data-gift-at-max');
        return;
      }
      var max = Math.max(1, (giftByLine[li] || 0) + spare);
      input.max = String(max);
      // Ramène toute valeur au-dessus du quota (saisie au clavier incluse, que
      // le max natif seul n'empêche pas) puis relance le moteur sur la valeur
      // corrigée.
      if ((parseInt(input.value, 10) || 1) > max) {
        input.value = String(max);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      slot.toggleAttribute('data-gift-at-max', (parseInt(input.value, 10) || 1) >= max);
    });
  }

  // [CUSTOM] Balise « Cadeau » d'une ligne comportant des unités cadeaux.
  function giftBadgeHtml(gifts) {
    if (!gifts) return '';
    return (
      '<span class="badge badge--highlight flex items-center gap-1d5 font-medium leading-none">' +
      (gifts > 1 ? gifts + ' cadeaux' : 'Cadeau') +
      '</span>'
    );
  }

  // Rendu d'une ligne en mode progressif. plan = { pcts, positions } par unité.
  //
  // Sous la ligne de prix, une paire de badges par groupe de remise (calquée sur
  // le cart drawer) : badge--highlight « Nᵉ produit » + badge--onsale « -X% ».
  // Une ligne ne porte normalement qu'un seul palier (cf. normalizeProgressiveSlots
  // pour le pack, computeCartRows pour le panier) ; le regroupement par % reste
  // en place comme filet, le temps d'un passage du moteur.
  function renderProgressiveLine(priceEl, unit, qty, plan) {
    var pcts = (plan && plan.pcts) || [];
    var positions = (plan && plan.positions) || [];
    var lastQty = lastTierQty();

    // Groupes consécutifs de même %.
    var groups = [];
    for (var i = 0; i < qty; i++) {
      var pct = pcts[i] || 0;
      var prev = groups[groups.length - 1];
      if (prev && prev.pct === pct) {
        prev.count++;
      } else {
        groups.push({ pct: pct, count: 1, pos: positions[i] });
      }
    }

    var hasDiscount = groups.some(function (g) {
      return g.pct > 0;
    });

    // Aucune position remisée (ex. produit le plus cher = position de tête) :
    // prix normal, pas de balise.
    if (!hasDiscount) {
      priceEl.className = 'price text-sm flex flex-wrap items-center gap-1d5';
      priceEl.innerHTML = money(unit);
      return;
    }

    // [CUSTOM] Prix affiché : TOUJOURS unitaire — une ligne ne porte qu'un seul
    // palier, sa quantité étant lue dans le sélecteur (produits du pack) ou
    // rappelée en « × N » (produits du panier). Même convention que le cart
    // drawer (cf. renderCartSplitRow dans tiered-bundle.js).
    var reducedShown = unit * (1 - (pcts[0] || 0) / 100);
    var originalShown = unit;

    // Balises par palier : cadeau (100 %) → highlight SEUL (« -100% » n'a pas de
    // sens pour un produit offert) ; sinon -X% + position.
    var badgeGroups = [];
    groups.forEach(function (g) {
      if (g.pct <= 0) return;
      var isGift = g.pct >= 100;
      var label = isGift
        ? (g.count > 1 ? g.count + ' cadeaux' : 'Cadeau')
        : positionLabel(g.pos, lastQty);
      var highlight =
        '<span class="badge badge--highlight flex items-center gap-1d5 font-medium leading-none">' + label + '</span>';
      badgeGroups.push(
        isGift
          ? { html: highlight, count: 1 }
          : {
              html:
                highlight +
                '<span class="badge badge--onsale flex items-center gap-1d5 font-medium leading-none">-' + g.pct + '%</span>',
              count: 2
            }
      );
    });

    // Une seule balise au total → inline, à droite du prix ; deux ou plus → toutes
    // en dessous (même règle que le cart drawer, cf. renderCartLineGroups).
    var totalBadges = 0;
    badgeGroups.forEach(function (b) { totalBadges += b.count; });
    var inline = totalBadges === 1;

    var badgesHtml = '';
    if (!inline) {
      badgeGroups.forEach(function (b) {
        badgesHtml +=
          '<div class="collection-bundle__line-badges flex flex-wrap items-center gap-1d5">' + b.html + '</div>';
      });
    }

    priceEl.className = 'price price--on-sale text-sm flex flex-col gap-1d5';
    priceEl.innerHTML =
      '<div class="collection-bundle__line-price flex flex-wrap items-center gap-1d5">' +
      '<span class="price__regular whitespace-nowrap">' + priceOrFree(reducedShown) + '</span>' +
      '<span class="price__sale inline-flex items-center relative">' + money(originalShown) + '</span>' +
      (inline ? badgeGroups[0].html : '') +
      '</div>' +
      badgesHtml;
  }

  // [CUSTOM] Pied de pack (mode progressif) : phrase récap de l'économie totale
  // avec la balise de réduction classique (badge--onsale). Injectée en fin de
  // .product-bundle__body avec un order élevé → toujours sous le dernier produit.
  // Le total couvre TOUT ce qui est affiché dans le pack : produits ajoutés ET
  // produits du panier (leurs lignes portent déjà chacune leur remise).
  function updateSavedLine(pack, total) {
    var body = pack.querySelector('.product-bundle__body');
    if (!body) return;
    var line = body.querySelector('[data-bundle-saved-line]');
    if (!isProgressive() || total <= 0.5) {
      if (line) line.hidden = true;
      return;
    }
    if (!line) {
      line = document.createElement('div');
      line.setAttribute('data-bundle-saved-line', '');
      line.className =
        'collection-bundle__saved-line flex flex-col items-center gap-1 text-sm font-medium';
      line.style.order = '100000000';
      body.appendChild(line);
    }
    line.hidden = false;
    line.innerHTML =
      '<div class="flex items-center justify-center gap-1d5">' +
      '<span>Vous avez économisé</span>' +
      '<span class="badge badge--onsale flex items-center gap-1d5 font-medium leading-none">-' +
      money(total) +
      '</span>' +
      '</div>';
  }

  // [CUSTOM] Normalise les slots du pack en mode progressif :
  //   UNE LIGNE = UN PRODUIT À UN PALIER, sa quantité étant le nombre d'unités
  //   de ce palier.
  //   • plusieurs unités d'un même produit qui partagent le palier → une seule
  //     ligne, dont le sélecteur de quantité natif reste utilisable ;
  //   • une ligne dont les unités relèvent de paliers différents (quantité
  //     augmentée par le sélecteur, ou positions décalées par un autre ajout)
  //     est éclatée en une ligne par palier.
  //
  // Le nombre TOTAL d'unités est conservé : les positions — donc le plan de
  // remise — restent valables, un seul recalcul suffit après normalisation
  // (cf. applyEngine). Retourne true si le DOM a changé.
  function normalizeProgressiveSlots(pack, res) {
    var planByLine = (res && res.planByLine) || null;
    if (!planByLine) return false;

    // Unités regroupées par variante, dans l'ordre des positions : à prix égal,
    // computeProgressivePlan classe les unités dans l'ordre des slots.
    var order = [];
    var byVariant = {};
    slotsOf(pack).forEach(function (slot, li) {
      var vid = slot.getAttribute('data-variant-id');
      if (!byVariant[vid]) {
        byVariant[vid] = { slots: [], pcts: [] };
        order.push(vid);
      }
      byVariant[vid].slots.push(slot);
      var plan = planByLine[li];
      (plan ? plan.pcts : []).forEach(function (pct) {
        byVariant[vid].pcts.push(pct);
      });
    });

    var changed = false;
    order.forEach(function (vid) {
      var entry = byVariant[vid];
      // Paliers consécutifs de cette variante → une ligne attendue par palier.
      var groups = [];
      entry.pcts.forEach(function (pct) {
        var prev = groups[groups.length - 1];
        if (prev && prev.pct === pct) prev.qty++;
        else groups.push({ pct: pct, qty: 1 });
      });
      if (!groups.length) return;

      var lastInput = null;
      groups.forEach(function (g, i) {
        var slot = entry.slots[i];
        if (!slot) {
          slot = addSlotLike(pack, entry.slots[0]);
          if (!slot) {
            // Création impossible (carte produit disparue de la grille) : on
            // reporte les unités sur la ligne précédente plutôt que de les
            // perdre — le rendu affichera alors 2 paliers sur cette ligne.
            if (lastInput) {
              lastInput.value = String((parseInt(lastInput.value, 10) || 0) + g.qty);
            }
            return;
          }
          changed = true;
        }
        var input = slot.querySelector('quantity-input input');
        if (!input) return;
        if (input.value !== String(g.qty)) {
          input.value = String(g.qty);
          changed = true;
        }
        lastInput = input;
      });

      // Lignes en trop (leurs unités ont été reportées sur les lignes gardées).
      entry.slots.slice(groups.length).forEach(function (slot) {
        pack.dispatchEvent(
          new CustomEvent('bundle:removed', { bubbles: true, detail: { variant: slot } })
        );
        changed = true;
      });
    });
    return changed;
  }

  function slotsOf(pack) {
    return Array.prototype.slice.call(
      pack.querySelectorAll('[data-product-bundle-variant][data-variant-id]')
    );
  }

  // Ajoute une ligne pour la même variante qu'un slot existant et retourne le
  // slot créé (le web component réutilise un emplacement vide ou clone son
  // gabarit — on identifie donc le nouveau par comparaison).
  function addSlotLike(pack, sourceSlot) {
    var product = sourceSlot.product;
    var variant = variantFromSlot(sourceSlot);
    if (!variant.id || !product || !product.querySelector('[data-product-bundle-title]')) {
      return null;
    }
    var before = slotsOf(pack);
    pack.dispatchEvent(
      new CustomEvent('bundle:added', {
        bubbles: true,
        detail: { product: product, variant: variant }
      })
    );
    var added = null;
    slotsOf(pack).forEach(function (slot) {
      if (!added && before.indexOf(slot) === -1) added = slot;
    });
    return added;
  }

  // [CUSTOM] Expose les unités de TOUS les packs (panier exclu — géré à part) à
  // tiered-bundle.js via window.__collectionBundlePackUnits, puis déclenche son
  // recalcul. La grille et le modal « choisir les options » ajoutent ces unités
  // au panier pour l'aperçu prix/réduction ; l'œil (quick view) reste au panier
  // seul (distinction faite côté tiered-bundle.js via data-bundle-controls).
  function publishPackUnits() {
    var units = [];
    document.querySelectorAll('product-bundle.collection-bundle').forEach(function (pack) {
      readPackLines(pack).forEach(function (l) {
        if (!l.productId || !l.unit) return;
        for (var i = 0; i < l.qty; i++) {
          units.push({ productId: l.productId, basePrice: l.unit, comparePrice: 0 });
        }
      });
    });
    window.__collectionBundlePackUnits = units;
    if (window.__tieredBundlePricing && typeof window.__tieredBundlePricing.applyAll === 'function') {
      window.__tieredBundlePricing.applyAll();
    }
  }

  // [CUSTOM] Ordre d'affichage des lignes (CSS order), produits du pack et
  // produits du panier mélangés :
  //   • mode progressif → ORDRE DES PALIERS : chaque ligne prend sa position
  //     dans le classement (1re position en haut). Deux produits au même prix
  //     unitaire sont donc départagés par leur remise — le moins remisé (prix
  //     réduit le plus élevé) passe devant, comme dans le cart drawer ;
  //   • sinon → prix unitaire décroissant (aucune position n'est calculée).
  // Les valeurs restent NÉGATIVES pour que les slots vides (order 0, 1, 2… posé
  // par reorderVariants) et la ligne cadeau restent sous les lignes remplies.
  var PROGRESSIVE_ORDER_BASE = -1000000;

  function applyLineOrder(pack, res, cartRows) {
    var planByLine = (res && res.planByLine) || null;
    pack.querySelectorAll('[data-product-bundle-variant][data-variant-id]').forEach(function (slot, li) {
      var pe = slot.querySelector('[data-product-bundle-variant-price]');
      var unit = pe ? parseInt(pe.getAttribute('data-price'), 10) || 0 : 0;
      slot.style.order = String(lineOrderValue(planByLine && planByLine[li], unit, !!planByLine));
    });
    pack.querySelectorAll('[data-bundle-cart-item]').forEach(function (el, ri) {
      var row = cartRows[ri];
      if (!row) return;
      el.style.order = String(lineOrderValue(row.plan, row.line.unit, !!row.plan));
    });
  }

  function lineOrderValue(plan, unit, progressive) {
    if (!progressive) return -unit;
    // Sans position connue (cas théorique) : en fin de liste remplie.
    if (!plan || !plan.positions.length) return PROGRESSIVE_ORDER_BASE + 999999;
    return PROGRESSIVE_ORDER_BASE + plan.positions[0];
  }

  // Séparateurs corrects malgré le réordonnancement : retire le bord du 1er
  // élément VISUEL (order le plus petit) et le padding bas du dernier. CSS order
  // casse `+ .horizontal-product`. Les slots masqués par la fusion du dernier
  // palier sont exclus.
  function updateLineSeparators(pack) {
    pack.querySelectorAll('.product-bundle__body .horizontal-product.is-bundle-first, .product-bundle__body .horizontal-product.is-bundle-last').forEach(function (el) {
      el.classList.remove('is-bundle-first');
      el.classList.remove('is-bundle-last');
    });
    // Liste ordonnée des éléments VISUELS (order croissant) : lignes panier et
    // produits du pack mélangés, classés par prix décroissant.
    var visualItems = Array.prototype.slice.call(
      pack.querySelectorAll('.product-bundle__body [data-bundle-cart-item], .product-bundle__body [data-product-bundle-variant][data-variant-id]')
    ).filter(function (el) {
      return el.style.display !== 'none';
    }).sort(function (a, b) {
      return (parseFloat(a.style.order) || 0) - (parseFloat(b.style.order) || 0);
    });
    if (!visualItems.length) return;
    visualItems[0].classList.add('is-bundle-first');
    visualItems[visualItems.length - 1].classList.add('is-bundle-last');
  }

  function applyEngine(pack) {
    var lines = readPackLines(pack);
    // [CUSTOM] Produits du panier éligibles, affichés comme des lignes du pack.
    var cartLines = readCartLines();

    // [CUSTOM] Classe is-progressive pour le style. Une ligne y porte toujours un
    // seul palier, avec sa quantité (cf. normalizeProgressiveSlots).
    pack.classList.toggle('is-progressive', isProgressive());

    // Min / max basés sur la QUANTITÉ totale (produits regroupés), pas le nombre
    // de slots. Le web component compte des slots ; on écrase son verdict ici.
    var totalQty = 0;
    lines.forEach(function (l) {
      totalQty += l.qty;
    });
    // Quantité effective = pack + produits déjà au panier éligibles.
    var effectiveQty = totalQty + cartQtyFor(unionTieredIds());

    var min = parseInt(pack.getAttribute('data-minimum'), 10) || 0;
    var max = parseInt(pack.getAttribute('data-maximum'), 10) || 0;
    var unlimited = pack.hasAttribute('data-unlimited');
    var submit = pack.querySelector('[data-product-bundle-submit]');
    if (submit) submit.disabled = totalQty < 1 || effectiveQty < min;
    var wrapper = pack.closest('.product-bundle-wrapper');
    if (wrapper) wrapper.toggleAttribute('locked', !unlimited && max > 0 && effectiveQty >= max);

    // Prix affiché à droite du titre (mode replié mobile) + bouton ATC.
    var originalTotal = 0;
    lines.forEach(function (l) {
      originalTotal += l.unit * l.qty;
    });
    var headPrice = pack.querySelector('[data-bundle-head-price]');
    if (headPrice) headPrice.hidden = totalQty === 0;

    var rules = window.__collectionBundleRules;

    // [CUSTOM] Barre de progression multi-paliers : les unités déjà offertes
    // (cadeaux, -100 %) ne comptent pas comme un produit qui fait progresser
    // vers le palier suivant — seule la quantité PAYANTE avance la barre. Le
    // palier lui-même reste franchi normalement : seul l'affichage du curseur exclut les unités offertes.
    var giftUnitsInPack = 0;
    if (rules) {
      var giftByLineForProgress = allocateGiftUnits(rules, lines);
      Object.keys(giftByLineForProgress).forEach(function (li) {
        giftUnitsInPack += giftByLineForProgress[li];
      });
    }
    var progressQty = Math.max(0, effectiveQty - giftUnitsInPack);
    updateProgress(pack, progressQty);
    // [CUSTOM] Palier infini : sous la barre, rappel de la remise max une fois
    // le dernier palier atteint (séparateur vers la 1re ligne produit en CSS).
    updateUnlimitedHint(pack, progressQty);

    var displayTotal = originalTotal;
    var compare = pack.querySelector('[data-bundle-total-compare]');
    var saved = 0;
    var res = null;
    var cartRows = [];

    if (rules && (rules.tiered || []).length) {
      res = computeDiscount(rules, lines, cartLines);

      // [CUSTOM] Une ligne = un produit à UN palier : regroupe les unités d'un
      // même palier et éclate celles de paliers différents. Le nombre d'unités
      // étant conservé, un seul recalcul suffit ensuite.
      if (isProgressive() && normalizeProgressiveSlots(pack, res)) {
        lines = readPackLines(pack);
        res = computeDiscount(rules, lines, cartLines);
      }
      saved = res.original - res.discounted;

      // Prix par ligne (réduit + barré + badge)
      renderLinePrices(pack, res);

      // [CUSTOM] Lignes « produit du panier » : découpage par palier (le plan de
      // remise doit donc être calculé avant de construire le DOM).
      cartRows = computeCartRows(cartLines, res);

      // [CUSTOM] Ligne « choisir un cadeau » (placeholder pointillé)
      updateGiftLine(pack, rules, lines, res);

      // [CUSTOM] Bloque la quantité des lignes cadeau au quota du palier atteint.
      applyGiftQuantityLimits(pack, rules, lines, res);

      // [CUSTOM] Badge gifts_badge sur les cartes de la grille « Vos cadeaux »,
      // scoped à CETTE grille (dès que le PACK, pas le panier réel, atteint un
      // palier cadeau — cf. applyGiftBadges dans tiered-bundle.js pour le panier
      // réel, sitewide).
      applyGiftsGridBadges(pack, rules, lines);

      // [CUSTOM] Récap économie totale en pied de pack (mode progressif) :
      // produits du pack + produits du panier affichés dans le pack.
      updateSavedLine(pack, saved + cartLinesSaved(cartLines, res));

      // [CUSTOM] Publie les unités du pack pour tiered-bundle.js (grille + modal).
      publishPackUnits();

      if (saved > 0.5) {
        displayTotal = res.discounted;
        if (compare) {
          compare.innerHTML = money(res.original);
          compare.hidden = false;
        }
      } else if (compare) {
        compare.hidden = true;
      }
    } else if (compare) {
      compare.hidden = true;
    }

    // [CUSTOM] Lignes « produit du panier » : construites APRÈS le moteur (leur
    // découpage dépend des paliers atteints), et avant les séparateurs.
    syncCartLines(pack, cartRows);
    renderCartLinePrices(pack, cartRows, res);

    // Ordre d'affichage : après le moteur (les positions viennent du plan).
    applyLineOrder(pack, res, cartRows);

    // Séparateurs : en toute fin, une fois les lignes panier créées et les slots
    // du dernier palier fusionnés — sinon le 1er / dernier élément VISUEL serait
    // calculé sur un état obsolète.
    updateLineSeparators(pack);

    // [CUSTOM] Total affiché stocké + appliqué. Le web component réécrit le prix
    // du bouton au total NON remisé via son handler « change » debouncé (~300 ms)
    // → glitch. Un MutationObserver (cf. initEngine) restaure ce total AVANT
    // repaint, ce qui supprime le flash.
    pack.__tbTotals = {
      plain: moneyPlain(displayTotal),
      cur: money(displayTotal),
      comparePlain: saved > 0.5 ? moneyPlain(originalTotal) : null,
    };
    applyBundleTotals(pack);
  }

  // Applique le total stocké (bouton ATC + prix du titre), sans réécrire si
  // déjà correct (évite les boucles avec le MutationObserver).
  function applyBundleTotals(pack) {
    var t = pack.__tbTotals;
    if (!t) return;
    var totalPlain = pack.querySelector('[data-product-bundle-total]');
    var totalCur = pack.querySelector('[data-product-bundle-total-with-currency]');
    var headTotal = pack.querySelector('[data-bundle-head-total]');
    var headCompare = pack.querySelector('[data-bundle-head-compare]');
    var headPrice = pack.querySelector('[data-bundle-head-price]');
    if (totalPlain && totalPlain.innerHTML !== t.plain) totalPlain.innerHTML = t.plain;
    if (totalCur && totalCur.innerHTML !== t.cur) totalCur.innerHTML = t.cur;
    if (headTotal && headTotal.innerHTML !== t.plain) headTotal.innerHTML = t.plain;
    if (headCompare && headPrice) {
      if (t.comparePlain) {
        if (headCompare.innerHTML !== t.comparePlain) headCompare.innerHTML = t.comparePlain;
        headCompare.hidden = false;
        headPrice.classList.add('price--on-sale');
      } else {
        headCompare.hidden = true;
        headPrice.classList.remove('price--on-sale');
      }
    }
  }

  /* ── Barre de progression multi-paliers (cercles type shipping bar) ── */
  function getTiers() {
    var rules = window.__collectionBundleRules;
    if (!rules || !(rules.tiered || []).length) return [];
    var map = {};
    rules.tiered.forEach(function (rule) {
      (rule.tiers || []).forEach(function (t) {
        if (t.qty <= 0) return;
        // [CUSTOM] Un palier peut n'accorder que des cadeaux (pct = 0) : on le
        // garde dans la barre et on retient le meilleur gain de chaque quantité.
        var cur = map[t.qty] || { pct: 0, giftQty: 0 };
        map[t.qty] = {
          pct: Math.max(cur.pct, t.pct || 0),
          giftQty: Math.max(cur.giftQty, t.giftQty || 0)
        };
      });
    });
    return Object.keys(map)
      .map(function (q) {
        return { qty: parseInt(q, 10), pct: map[q].pct, giftQty: map[q].giftQty };
      })
      .sort(function (a, b) { return a.qty - b.qty; });
  }

  // [CUSTOM] Gain affiché sur un cercle de la barre : « -15% », « 1 cadeau »,
  // ou les deux quand le palier accorde une remise ET des cadeaux.
  function tierGainLabel(t) {
    var parts = [];
    if (t.pct > 0) parts.push('-' + t.pct + '%');
    if (t.giftQty > 0) parts.push(t.giftQty > 1 ? t.giftQty + ' cadeaux' : '1 cadeau');
    return parts.join(' + ');
  }

  function tierLabel(qty) {
    // [CUSTOM] Mode progressif : le seuil est une POSITION → « 2ᵉ produit », et
    // le dernier palier « Nᵉ+ produit » (cf. positionLabel).
    if (isProgressive()) return positionLabel(qty, lastTierQty());
    return qty + ' ' + (qty > 1 ? 'produits' : 'produit');
  }

  function buildProgress(pack) {
    var tracks = pack.querySelectorAll('[data-bundle-progress-track]');
    if (!tracks.length) return;
    var tiers = getTiers();
    if (!tiers.length) {
      pack.querySelectorAll('[data-bundle-progress]').forEach(function (w) { w.style.display = 'none'; });
      return;
    }
    var html = '';
    tiers.forEach(function (t, i) {
      // Segment AVANT chaque cercle (jamais de cercle en tout début).
      html +=
        '<div class="collection-bundle__seg" data-seg="' + i + '"><span class="collection-bundle__seg-fill"></span></div>' +
        '<div class="collection-bundle__step" data-step="' + i + '" data-qty="' + t.qty + '">' +
          '<span class="collection-bundle__step-gain">' + tierGainLabel(t) + '</span>' +
          '<span class="collection-bundle__step-dot"></span>' +
          '<span class="collection-bundle__step-label">' + tierLabel(t.qty) + '</span>' +
        '</div>';
    });
    // Segment APRÈS le dernier cercle (jamais de cercle en toute fin).
    html += '<div class="collection-bundle__seg collection-bundle__seg--trail" data-seg="' + tiers.length + '"><span class="collection-bundle__seg-fill"></span></div>';
    tracks.forEach(function (track) { track.innerHTML = html; });
  }

  function updateProgress(pack, totalQty) {
    pack.querySelectorAll('[data-bundle-progress-track]').forEach(function (track) {
      updateTrack(track, totalQty);
    });
  }

  // [CUSTOM] Remise la plus haute parmi les paliers (typiquement le dernier).
  function highestTierPct() {
    var tiers = getTiers();
    var max = 0;
    tiers.forEach(function (t) {
      if (t.pct > max) max = t.pct;
    });
    return max;
  }

  // [CUSTOM] Affiche « Tous les produits supplémentaires à -X% » sous la barre quand le
  // dernier palier est atteint et que l'option palier infini est active.
  function updateUnlimitedHint(pack, totalQty) {
    var hint = pack.querySelector('[data-bundle-unlimited-hint]');
    if (!hint) return;
    var unlimited = pack.hasAttribute('data-unlimited');
    var lastQty = lastTierQty();
    var pct = highestTierPct();
    var show = unlimited && lastQty > 0 && totalQty >= lastQty && pct > 0;
    hint.hidden = !show;
    if (show) {
      var pctEl = hint.querySelector('[data-bundle-unlimited-pct]');
      if (pctEl) pctEl.textContent = String(pct);
    }
    pack.classList.toggle('has-unlimited-hint', show);
  }

  function updateTrack(track, totalQty) {
    var steps = track.querySelectorAll('.collection-bundle__step');
    var segs = track.querySelectorAll('.collection-bundle__seg');
    if (!steps.length) return;

    var tiers = [];
    steps.forEach(function (s) { tiers.push(parseInt(s.getAttribute('data-qty'), 10)); });

    var lastReached = -1;
    steps.forEach(function (step, i) {
      var reached = totalQty >= tiers[i];
      step.classList.toggle('is-reached', reached);
      step.classList.remove('is-collapsed-visible');
      step.classList.remove('is-current');
      if (reached) lastReached = i;
    });
    // [CUSTOM] Palier le plus loin atteint : mis en avant (texte vert marqué).
    if (lastReached >= 0 && steps[lastReached]) {
      steps[lastReached].classList.add('is-current');
    }

    var lastQty = tiers[tiers.length - 1];

    // [CUSTOM] Sens de variation : au RETOUR, l'avant-dernier segment (entre les 2
    // derniers cercles) se réduit EN DERNIER — après le segment final (immédiat) et
    // le dé-verdissement du cercle. À l'ALLER (approche), il reste réactif (délai 0).
    // Le délai n'est (dé)posé QUE lorsque le sens change (qty ≠ précédente) pour ne
    // pas perturber une transition en cours lors des re-runs à quantité identique.
    var prevQty = typeof track.__prevQty === 'number' ? track.__prevQty : totalQty;
    var reversing = totalQty < prevQty;
    var forward = totalQty > prevQty;
    track.__prevQty = totalQty;
    var preLastSegIdx = tiers.length - 1;

    segs.forEach(function (seg, i) {
      var fill = seg.querySelector('.collection-bundle__seg-fill');
      seg.classList.remove('is-filled', 'is-progress', 'is-collapsed-visible');
      if (fill && (reversing || forward)) {
        fill.style.transitionDelay = reversing && i === preLastSegIdx ? '0.5s' : '';
      }
      if (i >= tiers.length) {
        // Segment final (après le dernier cercle) : vert si tout atteint, sinon vide.
        if (totalQty >= lastQty) {
          seg.classList.add('is-filled');
          if (fill) fill.style.width = '100%';
        } else if (fill) {
          fill.style.width = '0%';
        }
        return;
      }
      var upper = tiers[i];
      var lower = i > 0 ? tiers[i - 1] : 0;
      if (totalQty >= upper) {
        seg.classList.add('is-filled');
        if (fill) fill.style.width = '100%';
      } else if (totalQty >= lower) {
        // Palier précédent atteint : amorce noire visible (min 12 %) qui progresse.
        seg.classList.add('is-progress');
        var frac = (totalQty - lower) / (upper - lower) * 100;
        if (fill) fill.style.width = Math.max(12, frac) + '%';
      } else if (fill) {
        fill.style.width = '0%';
      }
    });

    // Focus (mode replié) : cercle atteint + suivant, ou les deux derniers si tout atteint.
    var nextIndex = lastReached + 1;
    var focus = [];
    if (nextIndex < steps.length) {
      // Toujours 2 paliers visibles en replié (au départ : les 2 premiers).
      if (lastReached >= 0) {
        focus = [lastReached, nextIndex];
      } else {
        focus = steps.length >= 2 ? [0, 1] : [0];
      }
    } else {
      focus = steps.length >= 2 ? [steps.length - 2, steps.length - 1] : [steps.length - 1];
    }
    // Chaque cercle affiché est entouré d'un segment avant (seg[s]) et après (seg[s+1]).
    focus.forEach(function (s) {
      if (steps[s]) steps[s].classList.add('is-collapsed-visible');
      if (segs[s]) segs[s].classList.add('is-collapsed-visible');
      if (segs[s + 1]) segs[s + 1].classList.add('is-collapsed-visible');
    });
  }

  // Rafraîchit les données panier puis recalcule (quand le panier change ailleurs).
  // [CUSTOM] Même forme que cartItems émis par collection-bundle-config.liquid
  // (prix unitaire + titre / options / vignette) : les lignes « produit du
  // panier » du pack sont reconstruites à l'identique après un changement.
  function refreshCartAndRerun() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (window.__collectionBundleRules) {
          window.__collectionBundleRules.cartItems = (cart.items || []).map(function (it) {
            return {
              id: it.product_id,
              q: it.quantity,
              p: it.original_price,
              t: it.product_title,
              o: it.variant_title,
              img: it.image
            };
          });
        }
        document.querySelectorAll('product-bundle.collection-bundle').forEach(applyEngine);
      })
      .catch(function () {});
  }

  function initEngine() {
    var packs = document.querySelectorAll('product-bundle.collection-bundle');
    if (!packs.length) return;
    seedShortTitles();
    packs.forEach(function (pack) {
      buildProgress(pack);

      // [CUSTOM] Restaure le total remisé dès que le web component le réécrit
      // (handler debouncé → glitch du prix sur le bouton ATC). L'observer tourne
      // avant repaint → aucun flash. Le garde « déjà correct » d'applyBundleTotals
      // empêche la boucle.
      var totalObserver = new MutationObserver(function () {
        applyBundleTotals(pack);
      });
      ['[data-product-bundle-total]', '[data-product-bundle-total-with-currency]', '[data-bundle-head-total]', '[data-bundle-head-compare]']
        .forEach(function (sel) {
          var el = pack.querySelector(sel);
          if (el) totalObserver.observe(el, { childList: true, characterData: true, subtree: true });
        });

      var run = function () {
        // rAF : passe après onAddHandler/updateTotal du web component ;
        // timeout : passe après le handler « change » debouncé (300 ms) du thème.
        requestAnimationFrame(function () {
          applyEngine(pack);
        });
        setTimeout(function () {
          applyEngine(pack);
        }, 350);
      };
      pack.addEventListener('bundle:added', run);
      pack.addEventListener('bundle:removed', run);
      pack.addEventListener('change', run);

      // [CUSTOM] Indicateur cadeau flottant : réévalué au scroll du pack et à
      // l'ouverture / fermeture (transitionend sur le repli des produits).
      var scroller = pack.querySelector('.collection-bundle__scroll-content');
      if (scroller) {
        scroller.addEventListener('scroll', function () {
          updateGiftJump(pack);
        }, { passive: true });
      }
      pack.addEventListener('transitionend', function (e) {
        // products-wrap = repli desktop ; body-wrap = repli mobile.
        if (
          e.target === pack.querySelector('.collection-bundle__products-wrap') ||
          e.target === pack.querySelector('.collection-bundle__body-wrap')
        ) {
          updateGiftJump(pack);
        }
      });

      applyEngine(pack);
    });

    // Mise à jour quand le panier change (cart drawer, ajout au pack, etc.).
    if (window.theme && theme.pubsub && theme.pubsub.subscribe && theme.pubsub.PUB_SUB_EVENTS) {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, refreshCartAndRerun);
    }
    document.addEventListener('ajaxProduct:added', refreshCartAndRerun);

    // [CUSTOM] Filtrage : #ProductGridContainer est remplacé → la grille cadeaux
    // revient « is-locked » par défaut. On ré-applique le moteur UNE fois (pas
    // d'observer → pas de boucle) pour restaurer l'éligibilité + les prix bundle.
    document.addEventListener('collection:reloaded', function () {
      requestAnimationFrame(function () {
        document.querySelectorAll('product-bundle.collection-bundle').forEach(applyEngine);
      });
    });
  }

  if (document.readyState !== 'loading') initEngine();
  else document.addEventListener('DOMContentLoaded', initEngine);
})();
